import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.importHistoryTab';

export default defineMessages({
  emptyImportPageDescription: {
    id: `${scope}.emptyImportPageDescription`,
    defaultMessage: 'Make your content ready to use in Bronte by importing it here.',
  },
  emptyImportPageButton: {
    id: `${scope}.emptyImportPageButton`,
    defaultMessage: 'Get Started',
  },
});
